// Copyright (c) 2022 Deere & Company

import ClaimVsrMessage, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib//key-value-pair';
import {translate} from '../../../shared/services/translation-service';

export const addAuditVsrToClaim = claim => {

    const updatedClaim = claim;

    if (updatedClaim.errors) {

        // add the message to direct the user to instructions for completing the audit

        const message = translate('SELECTED_FOR_AUDIT_VSR');

        const auditVsr = new ClaimVsrMessage({
            ...getDefaultState(),
            message,
            messageId: 'SELECTED_FOR_AUDIT',
            messageNumber: '001',
            type: new KeyValuePair({
                key: 'W',
                value: 'Warn'
            })
        });

        updatedClaim.errors.push(auditVsr);

    }

    return updatedClaim;

};



// WEBPACK FOOTER //
// ./src/claim/shared/services/claim-vsr-helper.js